import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import BootstrapTable from 'react-bootstrap-table-next';
import moment from 'moment';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactGA from "react-ga4";

class ServiceReportUploadForm extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            userExists: userExists,
            partID: 1,
            machineID: 1,
            input: {
                firstName: userExists ? props.location.state.user.firstname : '',
                lastName: userExists ? props.location.state.user.lastname : '',
                email: userExists ? props.location.state.user.email : '',
                phoneNumber: userExists ? props.location.state.user.phone : '',
                accountNumber: '',
                reportType: 'Refrigerant Activity',
                serviceCallID: '',
                locationName: '',
                customerName: '',
                reviewRequired: '',
                serviceCallValid: false
            },
            reports: [],
            filteredReports: [],
            isEdit: false,
            loadingReports: false,
            defaultPartType: '',
            parts: [{ serialNumber: '', partType: '', error: '', id: 'part-0' }],
            machines: [{ id: 'machine-0', manufacturer: '', parentSerialNumber: '', parentModelNumber: '', circuitNumber:'', compressorNumber:'', errors: {}, parts: [{ serialNumber: '', partType: '', error: '', id: 'part-0', parent: 'machine-0' }]}],
            accounts: [],
            selectedRow:[],
            errors: {},
            loading: false,
            isDownloading: false,
            searchingServiceCall: false
        };

        this.fileControl = React.createRef();
        this.tableRef = React.createRef();
        this.radioYes = React.createRef();
        this.radioNo = React.createRef();
        this.handleFormChange = this.handleFormChange.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.showExtraData = this.showExtraData.bind(this);
        this.searchServiceCall = this.searchServiceCall.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this); 
        this.showButton = this.showButton.bind(this);
        this.showButtonDelete = this.showButtonDelete.bind(this);
        this.deleteReport = this.deleteReport.bind(this);
        this.showConfirmButton = this.showConfirmButton.bind(this);
        this.createSelectItems = this.createSelectItems.bind(this); 
        this.handleChildPartsChange = this.handleChildPartsChange.bind(this);
        this.getServiceReports = this.getServiceReports.bind(this);
        this.getServiceReportDetails = this.getServiceReportDetails.bind(this);
        this.handleOnSelect = this.handleOnSelect.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.showButtonDownload = this.showButtonDownload.bind(this);
        this.handleDownload = this.handleDownload.bind(this);
    }

    searchServiceCall() {

        this.setState({
            searchingServiceCall: true
        }, () => {
            axios.get(`${Constants.apiURL}/api/ServiceReporting/getServiceCall`, {
                params: {
                    serviceCallID: this.state.input.serviceCallID
                }
            }).then(response => {
                if (response.data != null && response.data != '') {
                    let input = this.state.input;
                    let errors = this.state.errors;
                    input.customerName = response.data.customerName;
                    input.locationName = response.data.locationName;
                    input.serviceCallKey = response.data.serviceCallKey;
                    input.serviceCallValid = true;
                    errors.serviceCallID = null;
                    this.setState(() => ({
                        searchingServiceCall: false,
                        input: input,
                        errors: errors
                    }));
                }
                else {
                    this.setState(() => ({
                        searchingServiceCall: false
                    }));
                    alert('Service call was not found.');
                }
            }).catch((response) => {
                // ? Show to user that request is failed
                this.setState({ errors: [response] })
                this.setState({ loading: false });
                console.log('request failed', response)
                alert('Service call was not found.');
            });
        });
    }
    componentDidMount() {
        this.getServiceReports();
    }
    getServiceReports() {

        this.setState({
            loadingReports: true
        }, () => {
            axios.get(`${Constants.apiURL}/api/ServiceReporting/GetReports`, {
                params: {
                    user: this.state.user.username
                }
            }).then(response => {
                if (response.data != null) {
                    this.setState(() => ({
                        loadingReports: false,
                        reports: response.data,
                        filteredReports:response.data
                    }));
                }
                else {
                    this.setState(() => ({
                        searchingServiceCall: false
                    }));
                    alert('Error grabbing reports.');
                }
            }).catch((response) => {
                // ? Show to user that request is failed
                this.setState({ errors: [response] })
                this.setState({ loading: false });
                console.log('request failed', response)
                alert('Error grabbing reports.');
            });
        });
    }
    getServiceReportDetails(id) {

        this.setState({
            loadingReports: true
        }, () => {
            axios.get(`${Constants.apiURL}/api/ServiceReporting/getReportDetails`, {
                params: {
                    user: this.state.user.user,
                    documentID: id
                }
            }).then(response => {
                if (response.data != null && response.data != '') {
                    console.log(response.data);
                    let input = this.state.input;
                    input.reportType = response.data.reportType;
                    input.serviceCallID = response.data.serviceCallID;
                    input.locationName = response.data.locationName;
                    input.customerName = response.data.customerName;
                    input.reviewRequired = response.data.reviewRequired;
                    input.serviceCallValid = true;
                    input.id = id;
                    this.setState(() => ({
                        loadingReports: false,
                        input: input,
                        machines: response.data.machines,
                        isEdit: true
                    }));
                }
                else {
                }
            }).catch((response) => {
                // ? Show to user that request is failed
                this.setState({ errors: [response] })
                this.setState({ loading: false });
                console.log('request failed', response)
                alert('Error loading report.');
            });
        });
    }
    createSelectItems() {
        let items = [];

        if (this.state.input.reportType == "Eddy Current Analysis") {
            items = [
                <option value="Condenser">Condenser</option>,
                <option value="Evaporator">Evaporator</option>
            ];
        }
        else if (this.state.input.reportType == "Vibration Analysis") {

            items = [
                <option value="Compressor">Compressor</option>,
                <option value="Pump">Pump</option>
            ];
        }

        return items;
    }
    handleChildPartsChange = (event, id, parent) => {
        this.setState((prevState) => {
            let machines = prevState.machines;
            machines.find((item) => item.id === parent).parts.find((item) => item.id === id)[event.target.name] = event.target.value;
            machines.find((item) => item.id === parent).parts.find((item) => item.id === id)["error"] = null;
            return { machines: machines };
        });
    }
    removePartsRow = (e, id, parent) => {
        let machine = this.state.machines.find((item) => item.id === parent);
        if (machine.parts.length < 2) { return; }
        this.setState((prevState) => {
            let machines = prevState.machines;
            machines.find((item) => item.id === parent).parts = machines.find((item) => item.id === parent).parts.filter((item) => item.id !== id);
            return { machines: machines };
        });
    }
    addPartsRow = (parent) => {
        this.setState((prevState) => {
            let machines = prevState.machines;
            machines.find((item) => item.id === parent).parts = [
                ...machines.find((item) => item.id === parent).parts,
                { serialNumber: '', type: this.state.defaultPartType, error: '', id: 'part-' + this.state.partID }
            ]

            return {
                machines: machines,
                partID: this.state.partID + 1
            }
        });
    }
    handleMachineChange = (event, id) => {
        this.setState((prevState) => {
            let newArrOfDivs = prevState.machines;
            newArrOfDivs.find((item) => item.id === id)[event.target.name] =
                event.target.value;
            newArrOfDivs.find((item) => item.id === id)["error"] = null;
            return { machines: newArrOfDivs };
        });
    }
    removeMachineRow = (id) => {
        if (this.state.machines.length < 2) { return; }
        this.setState((prevState) => {
            let newArr = prevState.machines.filter((item) => item.id !== id);
            return { machines: newArr };
        });
    }
    addMachineRow = () => {
        this.setState({
            machines: [
                ...this.state.machines,
                { id: 'machine-' + this.state.machineID, manufacturer: '', parentSerialNumber: '', parentModelNumber: '', circuitNumber: '', compressorNumber: '', errors: {}, parts: [{ serialNumber: '', partType: this.state.defaultPartType, error: '', id: 'part-'+this.state.partID, parent: 'machine-' + this.state.machineID }] }
            ],
            machineID: this.state.machineID + 1,
            partID: this.state.partID + 1
        });
    }
    showExtraData() {
        return (
            <div>
                <Col md={12}>
                    <Form.Label style={{
                        marginBottom: 5, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '16px', color: '#1F419B'
                    }}>Machines</Form.Label>
                </Col>
                {this.state.machines.map((item) => (
                    <div>
                        <Col md={10}> 
                            <hr />
                            </Col>
                        <Col md={12}>
                            <Form.Group as={Row} className="mb-3" >
                                <Form.Label column md={3} >Machine Manufacturer</Form.Label>
                                <Col md={9} style={{ maxWidth: '500px' }}>
                                    <Form.Control type="text" name="manufacturer" value={item.manufacturer} onChange={(e) => this.handleMachineChange(e, item.id)}
                                        isInvalid={!!item.errors.manufacturer} />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3" >
                                <Form.Label column md={3} >Machine Model #</Form.Label>
                                <Col md={9} style={{ maxWidth: '500px' }}>
                                    <Form.Control type="text" name="parentModelNumber" value={item.parentModelNumber} onChange={(e) => this.handleMachineChange(e, item.id)}
                                        isInvalid={!!item.errors.parentModelNumber} />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row} className="mb-3" >
                                <Form.Label column md={3} >Machine Serial #</Form.Label>
                                <Col md={9} style={{ maxWidth: '500px' }}>
                                    <Form.Control type="text" name="parentSerialNumber" value={item.parentSerialNumber} onChange={(e) => this.handleMachineChange(e, item.id)}
                                        isInvalid={!!item.errors.parentSerialNumber} />
                                </Col>
                            </Form.Group>
                        </Col>{this.state.input.reportType == "Oil Analysis" ?
                            <Col md={12}>
                                <Row style={{ paddingLeft: '5px' }}>
                                    <Form.Group as={Row} className="mb-3" >
                                        <Form.Label column md={3} >Circuit #</Form.Label>
                                        <Col md={9} style={{ maxWidth: '500px' }}>
                                            <Form.Control type="text" name="circuitNumber" value={item.circuitNumber} onChange={(e) => this.handleMachineChange(e, item.id)}
                                                isInvalid={!!item.errors.circuitNumber} />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3" >
                                        <Form.Label column md={3} >Compressor #</Form.Label>
                                        <Col md={9} style={{ maxWidth: '500px' }}>
                                            <Form.Control type="text" name="compressorNumber" value={item.compressorNumber} onChange={(e) => this.handleMachineChange(e, item.id)}
                                                isInvalid={!!item.errors.compressorNumber} />
                                        </Col>
                                    </Form.Group>
                                </Row >
                            </Col>
                            : this.state.input.reportType == "Eddy Current Analysis" || this.state.input.reportType == "Vibration Analysis"  ?

                                <div>
                                    <Row>
                                        <Col md={6} style={{ textAlign: 'center' }}>
                                            <Form.Label>Serial #</Form.Label>
                                        </Col>
                                        <Col md={4} style={{ textAlign: 'center' }}>
                                            <Form.Label>Part Type</Form.Label>
                                        </Col>
                                    </Row>
                                    {item.parts.map((part) => (
                                        <Form.Group as={Row} key={part.id} style={{ marginBottom: '0px !important;' }}>
                                            <Col md={6}>
                                                <Form.Control name="serialNumber" type="text" value={part.serialNumber} onChange={(e) => this.handleChildPartsChange(e, part.id, item.id)}
                                                    isInvalid={!!part.error} />
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Select name="partType" value={part.partType} onChange={(e) => this.handleChildPartsChange(e, part.id, item.id)}>
                                                        {this.createSelectItems()}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col style={{ width: 'auto' }}>
                                                <Button style={{ backgroundColor: '#1F419B', width: 'auto', borderRadius: '10px', marginLeft: '-15px', marginTop: '2px' }} variant="primary" onClick={(e) => this.removePartsRow(e, part.id, item.id)}>X</Button>
                                            </Col>
                                        </Form.Group>
                                    ))}
                                    <Row>
                                        <Col md={10} style={{ textAlign: 'end' }}>
                                            <Button style={{ backgroundColor: '#1F419B', width: 'auto' }} variant="primary" onClick={() => this.addPartsRow(item.id)}>Add part</Button>
                                        </Col>
                                    </Row>
                                </div>
                                : <div />}

                        <Row hidden={this.state.machines[0].id == item.id}>
                            <Col md={10} style={{ textAlign: 'end', marginTop: '10px' }}>
                                <Button style={{ backgroundColor: '#EF4139', width: 'auto' }} variant="primary" onClick={() => this.removeMachineRow(item.id)}>Remove machine</Button>
                            </Col>
                        </Row>
                    </div>
                ))}

            </div>


        );
    }
    handleFormChange(event) {
        let input = this.state.input;
        let errors = this.state.errors;

        if (event.target.name == 'serviceCallID') {
            input.customerName = '';
            input.locationName = '';
            input.serviceCallValid = false;
        }

        if (event.target.name == 'reportType') {
            let machines = this.state.machines;
            let defaultPartType = '';
            if (event.target.value == "Eddy Current Analysis") {
                defaultPartType = 'Condenser';
            }
            else if (event.target.value == "Vibration Analysis") {
                defaultPartType = 'Compressor';
            }
            for (var index in machines) {
                machines[index].parts = [{ serialNumber: '', partType: defaultPartType, id: 0 }];
            }

            this.setState({
                machines: machines,
                defaultPartType: defaultPartType
            });
        }

        input[event.target.name] = event.target.value;
        if (!!errors[event.target.name]) {
            errors[event.target.name] = null;
        }

        this.setState({
            input,
            errors
        });
    }
    validate() {
        let input = this.state.input;
        let errors = {};
        let isValid = true;
        console.log(input);
        if (!this.state.isEdit) {
            if (this.fileControl.current.files.length == 0) {
                isValid = false;
                errors["reportFile"] = "Invalid.";
            }
        }
        if (!input["reviewRequired"]) {
            isValid = false;
            errors["reviewRequired"] = "Invalid.";
        }

        if (input["serviceCallValid"] != true) {
            isValid = false;
            errors["serviceCallID"] = "Invalid";
            if (input["serviceCallID"] != '') {
                alert('Service Call ID is not valid');
            }
        }



        let machines = this.state.machines;
        for (var index in machines) {
            if (!machines[index]["manufacturer"]) {
                isValid = false;
                machines[index].errors["manufacturer"] = "Invalid.";
            }
            if (!machines[index]["parentModelNumber"]) {
                isValid = false;
                machines[index].errors["parentModelNumber"] = "Invalid.";
            }
            if (!machines[index]["parentSerialNumber"]) {
                isValid = false;
                machines[index].errors["parentSerialNumber"] = "Invalid.";
            }
            if (input.reportType == "Oil Analysis") {
                if (!machines[index]["circuitNumber"]) {
                    isValid = false;
                    machines[index].errors["circuitNumber"] = "Invalid.";
                }
                if (!machines[index]["compressorNumber"]) {
                    isValid = false;
                    machines[index].errors["compressorNumber"] = "Invalid.";
                }
            }
            else if (input.reportType == "Refrigerant Activity") {
            }
            else {
                
                for (var pIndex in machines[index].parts) {
                    if (machines[index].parts[pIndex].serialNumber == '') {
                        machines[index].parts[pIndex].error = "Invalid";
                        isValid = false;
                    }
                }
            }
        }

        this.setState({
            errors: errors,
            machines: machines
        });

        return isValid;
    }
    handleSubmit(event) {

        event.preventDefault();
        if (!this.validate()) {
            alert('Please fill in required fields to proceed.');
            return;
        }

        let formData = new FormData();
        formData.append('user', this.state.user.user);
        for (var key in this.state.input) {
            formData.append(key, this.state.input[key]);
        }
        for (var index in this.state.machines) {
            formData.append(`machines[${index}].manufacturer`, this.state.machines[index].manufacturer);
            formData.append(`machines[${index}].parentSerialNumber`, this.state.machines[index].parentSerialNumber);
            formData.append(`machines[${index}].parentModelNumber`, this.state.machines[index].parentModelNumber);
            formData.append(`machines[${index}].circuitNumber`, this.state.machines[index].circuitNumber);
            formData.append(`machines[${index}].compressorNumber`, this.state.machines[index].compressorNumber);

            if (this.state.input.reportType == "Vibration Analysis" ||  this.state.input.reportType == "Eddy Current Analysis") {
                console.log('here');
                for (var pIndex in this.state.machines[index].parts) {
                    console.log('here2');
                    formData.append(`machines[${index}].parts[${pIndex}].serialNumber`, this.state.machines[index].parts[pIndex].serialNumber);
                    formData.append(`machines[${index}].parts[${pIndex}].partType`, this.state.machines[index].parts[pIndex].partType);
                }
            }
        }

        for (var i = 0; i < this.fileControl.current.files.length; i++) {
            formData.append('reportFile', this.fileControl.current.files[i]);
        }

        /////////////////!!!!!!!!!!!!
        //formData.append('username', this.state.user.username);
        this.setState({ loading: true });

        let apiURL = `${Constants.apiURL}/api/ServiceReporting/uploadServiceReport`;
        if (this.state.isEdit) apiURL = `${Constants.apiURL}/api/ServiceReporting/updateServiceReport`

        axios.post(apiURL, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            console.log(response);
            if (response.data && response.data == true) {
                ReactGA.event({
                    category: 'Service Reporting',
                    action: 'Add/Edit',
                    label: ''
                });
                alert('Success, report uploaded.');
                this.resetForm();
            }
            else {
                alert('Error processing your request');
            }
            this.setState({ loading: false });
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            alert('Error processing your request');
        });
    }
    showButton() {
        if (this.state.loading) {
            return <Button style={{  backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={this.state.isEdit ? { backgroundColor: '#00973A' } : {  backgroundColor: '#1F419B' }} variant="primary" type="submit">
                {!this.state.isEdit ? 'Submit' : 'Update'}
            </Button>
        }
    }
    showButtonDelete() {
        if (this.state.loadingDelete) {
            return <Button style={{ backgroundColor: 'red', marginLeft: '10px' }} hidden={!this.state.isEdit} onClick={this.deleteReport}>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ backgroundColor: 'red', marginLeft: '10px' }} hidden={!this.state.isEdit} onClick={this.deleteReport}>
                Delete
            </Button>
        }
    }
    showButtonDownload() {
        if (this.state.isDownloading) {
            return <Button style={{ backgroundColor: '#1F419B', marginLeft: '10px' }} hidden={!this.state.isEdit} onClick={this.handleDownload}>
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ backgroundColor: '#1F419B', marginLeft: '10px' }} hidden={!this.state.isEdit} onClick={this.handleDownload}>
                Download
            </Button>
        }
    }
    deleteReport() {

        this.setState({
            loadingDelete: true
        }, () => {
            axios.get(`${Constants.apiURL}/api/ServiceReporting/deleteReport`, {
                params: {
                    documentID: this.state.selectedRow[0]
                }
            }).then(response => {
                ReactGA.event({
                    category: 'Service Reporting',
                    action: 'Delete',
                    label: ''
                });
                this.resetForm();
                this.getServiceReports();
                alert('Report deleted.');
            }).catch((response) => {
                // ? Show to user that request is failed
                this.setState({ errors: [response] })
                this.setState({ loading: false, loadingDelete: false, loadingReports: false });
                console.log('request failed', response)
                alert('Failed to delete report.');
            });
        });
    }
    showConfirmButton() {
        if (this.state.searchingServiceCall) {
            return <Button style={{ backgroundColor: '#1F419B', width: '80px' }} variant="primary">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            if (this.state.input.serviceCallValid) {
                return <Button style={{ backgroundColor: '#00973A', width: '80px' }} variant="primary" disabled>
                    Valid
                </Button>
            }
            else {
                return <Button style={{ backgroundColor: '#1F419B', width: '80px' }} variant="primary" onClick={this.searchServiceCall}>
                    Confirm
                </Button>
            }
        }
    }
    onTableChange() { }
    resetForm() {
        this.setState({
            input: {
                reportType: 'Refrigerant Activity',
                serviceCallID: '',
                locationName: '',
                customerName: '',
                manufacturer: '',
                parentSerialNumber: '',
                parentModelNumber: '',
                reviewRequired: '',
                serviceCallValid: false
            },
            loadingDelete: false,
            loadingReports: false,
            selectedRow:[],
            isEdit: false,
            machines: [{ id: 'machine-0', manufacturer: '', parentSerialNumber: '', parentModelNumber: '', circuitNumber: '', compressorNumber: '', errors: {}, parts: [{ serialNumber: '', partType: '', error: '', id: 'part-0', parent: 'machine-0' }] }]
        });

        this.fileControl.current.value = null;
        this.radioNo.current.checked = false;
        this.radioYes.current.checked = false;
        this.getServiceReports();
    }
    handleOnSelect = (row, isSelect) => {
        this.setState({ selectedRow: [row.documentID] });
        this.getServiceReportDetails(row.documentID);
    }
    handleFilterChange(event) {
        let input = this.state;
        let filter = event.target.value;
        

        let x = this.state.reports.filter(function (ele) {
            if (ele.documentType.toLowerCase().includes(filter.toLowerCase())) return true;
            if (ele.serviceCallID.toLowerCase().includes(filter.toLowerCase())) return true; 
            if (ele.documentName.toLowerCase().includes(filter.toLowerCase())) return true;
            return false;
        });


        this.setState({
            filterReports: filter,
            filteredReports: x
        });
    }
    handleDownload() {
        this.setState({ isDownloading: true });
        axios.get(`${Constants.apiURL}/api/ServiceReporting/DownloadReport`, {
            params: {
                user: this.state.user.username,
                id: this.state.selectedRow[0]
            },
            responseType: "blob"
        }).then(response => {
            this.setState({ isDownloading: false });

            let blob = new Blob([response.data], { type: "application/pdf" }),
                downloadUrl = window.URL.createObjectURL(blob),
                filename = "",
                disposition = response.headers["content-disposition"];

            if (disposition && disposition.indexOf("attachment") !== -1) {
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                    matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, "");
                }
            }
            else {
                alert('We are unable to locate the selected document(s). Please email us at clientportal@boland.com for help with this issue.');
                return;
            }

            let a = document.createElement("a");
            if (typeof a.download === "undefined") {
                window.location.href = downloadUrl;
            } else {
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ isDownloading: false });
            console.log('request failed', response)
        });
    }
    render() {

        const selectRow = {
            mode: 'radio',
            hideSelectColumn: true,
            onSelect: this.handleOnSelect,
            selected: this.state.selectedRow,
            style: { backgroundColor: 'rgba(0,0,0,.2)' },
            clickToSelect: true
        };

        return (
            <div>
                <SiteMenu user={this.state.user} currentPage='analysisReportUpload' />
                <Form onSubmit={this.handleSubmit} noValidate style={{ margin: 10 }}>
                    <Row>
                        <Col md={6}>
                            <Form.Label style={{
                                paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B'
                            }}>File Upload, Edit, & Delete</Form.Label><br />
                            <Form.Label style={{ paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', paddingTop: '0px', fontStyle: 'italic', fontSize: '15px', marginBottom: '10px' }}>
                                Uploading service reports using the form below make these reports available to applicable customers and internal Boland personnel.</Form.Label>
                        <Form.Group as={Row} className="mb-3" > 
                            <Form.Label column md={3} >Analysis Report File</Form.Label>
                            <Col md={9} style={{ maxWidth: '500px' }}>
                                    <Form.Control name="reportFile" type="file" ref={this.fileControl} onChange={this.handleFormChange} accept=".pdf" disabled={this.state.isEdit}
                                    isInvalid={!!this.state.errors.reportFile} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" >
                            <Form.Label column md={3} >Report Type</Form.Label>
                            <Col md={9} style={{ maxWidth: '500px' }}>
                                <Form.Select name="reportType" value={this.state.input.reportType} onChange={this.handleFormChange}>
                                    <option value="Refrigerant Activity">Refrigerant Activity</option>
                                    <option value="Oil Analysis">Oil Analysis</option>
                                    <option value="Eddy Current Analysis">Eddy Current Analysis</option>
                                    <option value="Vibration Analysis">Vibration Analysis</option>
                                </Form.Select>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" >
                            <Form.Label column md={3} >Any Findings?</Form.Label>
                            <Col md={1}>
                                    <Form.Check ref={this.radioNo} value="No" label="No" name="reviewRequired" type='radio' id='radioNo' checked={this.state.input.reviewRequired === "No"} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.reviewRequired} />
                            </Col>
                            <Col md={1}>
                                    <Form.Check ref={this.radioYes} value="Yes" label="Yes" name="reviewRequired" type='radio' id='radioYes' checked={this.state.input.reviewRequired === "Yes"} onChange={this.handleFormChange}
                                    isInvalid={!!this.state.errors.reviewRequired} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" >
                            <Form.Label column md={3} >Service Call ID</Form.Label>
                            <Col md={9} style={{ maxWidth: '500px' }}>
                                <Form.Group as={Row} style={{ justifyContent: 'right', marginRight:'0px' }}>
                                    <Form.Control style={{ width: 'fit-content', flex: 1, marginRight: 5, maxWidth: '215px' }} type="text" name="serviceCallID" value={this.state.input.serviceCallID} onChange={this.handleFormChange}
                                        isInvalid={!!this.state.errors.serviceCallID} />
                                    {this.showConfirmButton()}
                                </Form.Group>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column md={3} >Location Name</Form.Label>
                            <Col md={9} style={{ textAlign: '-webkit-right', maxWidth: '500px' }}>
                                <Form.Control style={{ maxWidth: '300px' }} type="text" name="locationName" value={this.state.input.locationName} disabled />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column md={3}>Customer Name</Form.Label>
                            <Col md={9} style={{ textAlign: '-webkit-right', maxWidth: '500px' }}>
                                <Form.Control style={{ maxWidth: '300px' }} type="text" name="customerName" value={this.state.input.customerName} disabled />
                            </Col>
                        </Form.Group>
                        {this.showExtraData()}
                        <Row>
                            <Col md={10} style={{ textAlign: 'end', marginTop:'10px' }}>
                                <Button style={{ backgroundColor: '#1F419B', width: 'auto' }} variant="primary" onClick={() => this.addMachineRow()}>Add machine</Button>
                            </Col>
                        </Row>
                            {this.showButton()}
                            {this.showButtonDelete()}
                            {this.showButtonDownload()}
                            <Button style={{ marginLeft:'10px', backgroundColor: '#1F419B', width: '105px' }} variant="primary" onClick={this.resetForm}>Reset Form</Button>
                    </Col>
                        <Col md={6}>
                            <Row>
                                <Form.Label style={{ width: 'fit-content', margin: 3, marginLeft: 10 }} className="form-header">Loaded Service Reports</Form.Label>
                                <Col style={{width:'100%'}}/>
                                <Form.Control style={{ width: '300px', marginRight: 22 }} type="text" name="filterReports" value={this.state.filterReports} onChange={this.handleFilterChange} placeholder='Filter by name, type, service call ID...' />
                            </Row>
                            <BootstrapTable
                                bootstrap4
                                remote
                                bodyStyle={{ wordBreak: 'break-all' }}
                                keyField="documentID"
                                wrapperClasses="table-responsive"
                                data={this.state.filteredReports}
                                columns={reportColumns}
                                onTableChange={this.onTableChange}
                                selectRow={selectRow}
                                striped
                                ref={this.tableRef}
                                hover
                            />
                    </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

export default ServiceReportUploadForm;

function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY');
}
const reportColumns = [
    {
        text: 'Date Uploaded',
        dataField: 'createdDate',
        formatter: dateFormat,
        headerStyle: (colum, colIndex) => {
            return { width: '130px', textAlign: 'center' };
        }
    },
    {
        text: 'Type',
        dataField: 'documentType',
        headerStyle: (colum, colIndex) => {
            return { width: '200px', textAlign: 'center' };
        }
    },
    {
        text: 'Service Call ID',
        dataField: 'serviceCallID',
        headerStyle: (colum, colIndex) => {
            return { width: '140px', textAlign: 'center' };
        }
    },
    {
        text: 'File Name',
        dataField: 'documentName',
        headerStyle: (colum, colIndex) => {
            return { textAlign: 'center', wordBreak: 'break-all' };
        },
        style: (cell, row, rowIndex, colIndex) => {
            return { wordBreak: 'break-all' };
        }
    }];